import {
  Container,
  IconButton,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  FilterGroupContainer,
  FilterItems,
  FilterSelectionButton,
} from "../components-atoms";
import React, { useState } from "react";

import Button from "@material-ui/core/Button";
import FilterListRoundedIcon from "@material-ui/icons/FilterListRounded";
import Menu from "@material-ui/core/Menu";
import { TabPanel } from "../components-molecules";
import { ITheme, theme } from "../constants/theme";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";

export default function ShopFilterButton(props: any) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  /* const [filterTypeSelected, setFilterTypeSelected] =
    React.useState<boolean>(false);
  const [filterType, setFilterType] = React.useState<null | string>(); */
  const [index, setIndex] = useState(0);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const filterButtonCliked = () => {
    //
    setIndex(1);
  };
  return (
    <div>
      <Button
        id="shop-filter-button"
        aria-label="Filter"
        aria-controls={open ? "shop-filter-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        startIcon={<FilterListRoundedIcon color="primary" />}
        onClick={handleClick}
        style={{
          marginLeft: props.inButtonSet ? "8px" : undefined,
          backgroundColor: open ? theme.palette.secondary.main : undefined,
        }}
        className={classes.textButton}
      >
        {/* <img src={printIcon} className={classes.buttonIcon} alt="printIcon" /> */}
        <Typography
          variant="button"
          component="span"
          color="primary"
          className={classes.printButtonText}
        >
          Filter
        </Typography>
      </Button>
      <IconButton
        data-automation="search-button"
        className={classes.searchIconButton}
        color="primary"
        onClick={() => {
          props.onSearchIconClick();
        }}
      >
        <SearchRoundedIcon color="primary" className={classes.searchIcon} />
      </IconButton>

      <Menu
        id="shop-filter-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "shop-filter-button",
          role: "listbox",
        }}
        className={classes.menu}
      >
        <Container className={classes.titleContainer}>
          <Typography
            style={{ marginBottom: 15 }}
            variant="h6"
            component="span"
            color="textPrimary"
          >
            Filter
          </Typography>
        </Container>
        <Container className={classes.buttonContainer}>
          <Button
            id="basic-button"
            aria-controls="basic-menu"
            aria-haspopup="true"
            //onClick={handleClick}
          >
            <Typography
              variant="button"
              component="span"
              color="primary"
              className={classes.buttonText}
            >
              Clear all
            </Typography>
          </Button>
        </Container>
        <TabPanel value={index} index={0}>
          <Container className={classes.tabContainer}>
            <FilterSelectionButton
              title="Shop"
              text=""
              onClick={filterButtonCliked}
            />
            <FilterSelectionButton
              title="City"
              text=""
              onClick={filterButtonCliked}
            />
            <FilterSelectionButton
              title="Region"
              text=""
              onClick={filterButtonCliked}
            />
          </Container>
        </TabPanel>
        <TabPanel value={index} index={1}>
          <Container className={classes.tabContainer}>
            <FilterGroupContainer letter="A" count={12}>
              <FilterItems title="aaa" />
              <FilterItems />
            </FilterGroupContainer>
            <FilterGroupContainer letter="A" count={12}>
              <FilterItems title="aaa" />
              <FilterItems />
            </FilterGroupContainer>
            <FilterGroupContainer letter="A" count={12}>
              <FilterItems title="aaa" />
              <FilterItems />
            </FilterGroupContainer>
            <FilterGroupContainer letter="A" count={12}>
              <FilterItems title="aaa" />
              <FilterItems />
            </FilterGroupContainer>
            <FilterGroupContainer letter="A" count={12}>
              <FilterItems title="aaa" />
              <FilterItems />
            </FilterGroupContainer>
            <FilterGroupContainer letter="A" count={12}>
              <FilterItems title="aaa" />
              <FilterItems />
            </FilterGroupContainer>
          </Container>
        </TabPanel>
        <Container className={classes.bottomButtonContainer}>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            className={classes.primaryButton}
            style={{
              paddingLeft: props.loading ? "12px" : "16px",
            }}
          >
            Apply Filters
          </Button>
        </Container>
      </Menu>
    </div>
  );
}

const useStyles = makeStyles((theme: ITheme) => ({
  printButtonText: {
    textTransform: "none",
  },
  buttonText: {
    textTransform: "none",
  },
  buttonIcon: {
    width: 18,
    height: 18,
    marginRight: 8,
  },
  titleContainer: {
    minWidth: 320,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 24,
    paddingBottom: 16,
  },
  buttonContainer: {
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 6,
  },
  bottomButtonContainer: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8,
    paddingBottom: 24,
  },
  tabContainer: {
    width: "100%",
    height: 376,
    maxWidth: 320,
    paddingLeft: 4,
    paddingRight: 4,
    "overflow-y": "auto",
  },
  menu: {
    marginTop: 65,
    marginRight: 120,

    "& [class*=MuiPaper-rounded-]": {
      borderRadius: 12,
    },
  },
  primaryButton: {
    width: "100%",
    borderRadius: 8,
    "&:hover": {
      backgroundColor: theme.palette.primary[92],
    },
    "&:active": {
      backgroundColor: theme.palette.primary[76],
    },
  },
  textButton: {
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
    "&:active": {
      backgroundColor: theme.palette.secondary[24],
    },
  },
  searchIcon: {
    width: 24,
    height: 24,
  },
  searchIconButton: {
    width: 40,
    height: 40,
    marginLeft: 8,
  },
}));
